(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hot-craft-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    var loading = false, waiters = [];
    function loadThree(cb) {
      if (window.THREE) return cb();
      waiters.push(cb);
      if (loading) return;
      loading = true;
      var s = document.createElement('script'); s.src = THREE_SRC; s.async = true;
      s.onload = function () { waiters.forEach(function (f) { f(); }); waiters = []; };
      document.head.appendChild(s);
    }

    function initGlobe(root) {
      var data;
      try { data = JSON.parse(root.querySelector('[data-globe-data]').textContent); } catch (e) { return; }
      if (!data || !data.length) return;
      var THREE = window.THREE;
      var viz = root.querySelector('[data-globe-viz]');
      var canvas = root.querySelector('[data-globe-gl]');
      var pinsWrap = root.querySelector('[data-globe-pins]');
      var cards = root.querySelectorAll('.hot-globe__card');
      var chips = root.querySelectorAll('.hot-globe__chip');
      var TEX = 'https://threejs.org/examples/textures/planets/';
      // HOT: phones load only the colour map (512KB); specular, normal and cloud maps add 790KB
      var lite = window.matchMedia('(max-width: 749px)').matches;

      var W = viz.clientWidth || 480, H = viz.clientHeight || W;
      var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
      renderer.setSize(W, H, false);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));

      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(38, W / H, 0.1, 1000);
      camera.position.set(0, 0, 3.15);

      // Lights
      scene.add(new THREE.AmbientLight(0xffffff, 0.95));
      var sun = new THREE.DirectionalLight(0xfff2dd, 1.15);
      sun.position.set(-2, 1.2, 2.4);
      scene.add(sun);

      // Earth group (rotates)
      var group = new THREE.Group();
      scene.add(group);

      var loader = new THREE.TextureLoader();
      loader.setCrossOrigin('anonymous');
      var earthMat = new THREE.MeshPhongMaterial({ color: 0x2a4a6a, specular: new THREE.Color(0x222222), shininess: 9 });
      loader.load(TEX + 'earth_atmos_2048.jpg', function (t) { earthMat.map = t; earthMat.color.set(0xffffff); earthMat.needsUpdate = true; });
      if (!lite) loader.load(TEX + 'earth_specular_2048.jpg', function (t) { earthMat.specularMap = t; earthMat.specular.set(0x2a2a2a); earthMat.shininess = 11; earthMat.needsUpdate = true; });
      if (!lite) loader.load(TEX + 'earth_normal_2048.jpg', function (t) { earthMat.normalMap = t; earthMat.normalScale = new THREE.Vector2(0.7, 0.7); earthMat.needsUpdate = true; });
      var earth = new THREE.Mesh(new THREE.SphereGeometry(1, 64, 64), earthMat);
      group.add(earth);

      // Clouds
      var cloudMat = new THREE.MeshLambertMaterial({ transparent: true, opacity: 0.42, depthWrite: false });
      if (!lite) loader.load(TEX + 'earth_clouds_1024.png', function (t) { cloudMat.map = t; cloudMat.needsUpdate = true; });
      var clouds = new THREE.Mesh(new THREE.SphereGeometry(1.012, 48, 48), cloudMat);
      if (!lite) group.add(clouds);

      // Gold atmosphere (fresnel glow)
      var atmoMat = new THREE.ShaderMaterial({
        transparent: true, blending: THREE.AdditiveBlending, side: THREE.BackSide, depthWrite: false,
        vertexShader: 'varying vec3 vN; void main(){ vN = normalize(normalMatrix * normal); gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }',
        fragmentShader: 'varying vec3 vN; void main(){ float i = pow(0.62 - dot(vN, vec3(0.0,0.0,1.0)), 3.2); i = clamp(i,0.0,1.0); gl_FragColor = vec4(0.82,0.68,0.32,1.0) * i; }'
      });
      scene.add(new THREE.Mesh(new THREE.SphereGeometry(1.22, 48, 48), atmoMat));

      // Starfield
      var starGeo = new THREE.BufferGeometry(), starN = 1400, pos = new Float32Array(starN * 3);
      for (var i = 0; i < starN; i++) {
        var r = 60 + Math.random() * 40, th = Math.random() * Math.PI * 2, ph = Math.acos(2 * Math.random() - 1);
        pos[i * 3] = r * Math.sin(ph) * Math.cos(th); pos[i * 3 + 1] = r * Math.sin(ph) * Math.sin(th); pos[i * 3 + 2] = r * Math.cos(ph);
      }
      starGeo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
      scene.add(new THREE.Points(starGeo, new THREE.PointsMaterial({ color: 0xd8c79a, size: 0.5, sizeAttenuation: true, transparent: true, opacity: 0.8 })));

      // lat/lng -> unit vector (aligned to earth_atmos equirectangular map)
      function llv(lat, lng) {
        var phi = (90 - lat) * Math.PI / 180, theta = (lng + 180) * Math.PI / 180;
        return new THREE.Vector3(-Math.sin(phi) * Math.cos(theta), Math.cos(phi), Math.sin(phi) * Math.sin(theta));
      }

      // Anchors + HTML pins
      var anchors = [], pins = [];
      data.forEach(function (d, n) {
        var a = new THREE.Object3D(); a.position.copy(llv(d.lat, d.lng).multiplyScalar(1.02)); group.add(a); anchors.push(a);
        var btn = document.createElement('button');
        btn.className = 'hot-globe-pin' + (n === 0 ? ' is-active' : '');
        btn.setAttribute('data-i', n);
        btn.innerHTML = '<span class="hot-globe-pin__thumb"><img src="' + d.img + '" alt=""></span><span class="hot-globe-pin__dot"></span>';
        btn.addEventListener('click', function () { activate(n, true); });
        pinsWrap.appendChild(btn); pins.push(btn);
      });

      // Initial orientation: face India (first pin)
      var targetY = -Math.atan2(llv(data[0].lat, data[0].lng).x, llv(data[0].lat, data[0].lng).z);
      group.rotation.y = targetY;
      var spin = true, tween = null;

      function faceRot(d) {
        var v = llv(d.lat, d.lng);
        return { y: -Math.atan2(v.x, v.z), x: THREE.MathUtils.clamp(d.lat * Math.PI / 180 * 0.6, -0.5, 0.5) };
      }
      function activate(idx, fly) {
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === idx); });
        chips.forEach(function (c, n) { c.classList.toggle('is-active', n === idx); });
        pins.forEach(function (p, n) { p.classList.toggle('is-active', n === idx); });
        cards.forEach(function (c, n) { var v = c.querySelector('video'); if (v) { if (n === idx) v.play().catch(function () {}); else v.pause(); } });
        if (fly) {
          spin = false;
          var fr = faceRot(data[idx]);
          tween = { fromY: group.rotation.y, fromX: group.rotation.x, toY: fr.y, toX: fr.x, t: 0 };
          // shortest path on Y
          while (tween.toY - tween.fromY > Math.PI) tween.toY -= Math.PI * 2;
          while (tween.toY - tween.fromY < -Math.PI) tween.toY += Math.PI * 2;
        }
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { activate(+c.getAttribute('data-chip'), true); }); });

      // Pointer drag to rotate
      var drag = false, px = 0, py = 0;
      canvas.addEventListener('pointerdown', function (e) { drag = true; spin = false; tween = null; px = e.clientX; py = e.clientY; });
      window.addEventListener('pointerup', function () { drag = false; });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        group.rotation.y += (e.clientX - px) * 0.005; group.rotation.x += (e.clientY - py) * 0.005;
        group.rotation.x = THREE.MathUtils.clamp(group.rotation.x, -0.9, 0.9); px = e.clientX; py = e.clientY;
      });

      function resize() {
        W = viz.clientWidth || W; H = viz.clientHeight || W;
        renderer.setSize(W, H, false); camera.aspect = W / H; camera.updateProjectionMatrix();
      }
      window.addEventListener('resize', resize);

      var v2 = new THREE.Vector3(), camDir = new THREE.Vector3();
      function frame() {
        if (spin && !drag) group.rotation.y += 0.0016;
        clouds.rotation.y += 0.0006;
        if (tween) {
          tween.t = Math.min(1, tween.t + 0.02);
          var e = 1 - Math.pow(1 - tween.t, 3);
          group.rotation.y = tween.fromY + (tween.toY - tween.fromY) * e;
          group.rotation.x = tween.fromX + (tween.toX - tween.fromX) * e;
          if (tween.t >= 1) tween = null;
        }
        // project pins
        camera.getWorldPosition(camDir);
        anchors.forEach(function (a, n) {
          a.getWorldPosition(v2);
          var facing = v2.clone().normalize().dot(camDir.clone().normalize());
          var p = v2.clone().project(camera);
          var x = (p.x * 0.5 + 0.5) * W, y = (-p.y * 0.5 + 0.5) * H;
          var pin = pins[n];
          pin.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%)';
          var vis = facing > 0.12;
          pin.style.opacity = vis ? '1' : '0';
          pin.style.pointerEvents = vis ? 'auto' : 'none';
          pin.style.zIndex = Math.round(facing * 100);
        });
        renderer.render(scene, camera);
        requestAnimationFrame(frame);
      }
      root.classList.add('is-ready');
      activate(0, false);
      resize();
      requestAnimationFrame(frame);
    }

    document.querySelectorAll('[data-globe]').forEach(function (root) {
      if (!('IntersectionObserver' in window)) { loadThree(function () { initGlobe(root); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); loadThree(function () { initGlobe(root); }); } });
      }, { rootMargin: '300px' });
      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
